export const COLLECTION_PAGES = {
    "leather-bags": {
        slug: "leather-bags",
        series: "The Leather Bag House",
        title: "Leather Bags",
        sub: "Laptop · Sling · Travel — Men & Women",
        description:
            "From boardroom briefs to weekend duffles — every bag is cut, stitched and finished in our Kanpur workshop. Full-grain and NDM leather, solid brass hardware, padded compartments and custom embossing for your label.",
        features: [
            "Full-grain & NDM leather options",
            "Padded laptop compartments up to 15.6\u2033",
            "Custom embossing & private label",
            "OEM / ODM — made to your specification",
            "MOQ from 100 units · mixed-SKU kits",
            "FOB / CIF — sea & air freight",
        ],
        category: "Leather Laptop Bags",
        items: [
            { img: "/assets/laptop-1.png", title: "Meridian Brief — Tan" },
            { img: "/assets/laptop-2.png", title: "Meridian Brief — Espresso" },
            { img: "/assets/sling-onyx.png", title: "Voyager City Sling — Onyx" },
            { img: "/assets/sling-chestnut.png", title: "Voyager City Sling — Chestnut" },
            { img: "/assets/bag-sling.png", title: "Voyager Sling — Color Range" },
            { img: "/assets/bag-messenger.png", title: "Scout Vertical Messenger" },
            { img: "/assets/bag-waist.png", title: "Voyager Waist Pouch Range" },
            { img: "/assets/bag-duffle.png", title: "The Overlander Duffle" },
            { img: "/assets/bag-hide-duffle.png", title: "Hair-On Hide Weekender" },
            { img: "/assets/bag-backpack-green.png", title: "Emerald Trail Backpack" },
            { img: "/assets/bag-backpack-tan.png", title: "Summit Tan Rucksack" },
            { img: "/assets/bag-backpack-green-back.png", title: "Emerald Trail — Utility Back" },
        ],
    },
    wallets: {
        slug: "wallets",
        series: "The Statesman Series",
        title: "Men's Wallets",
        sub: "Bifolds · Cardholders · Money Clips",
        description:
            "Slim profiles, drum-dyed leathers and hand-finished edges. Our wallets are built for daily carry and retail presentation — with RFID-ready constructions, contrast stitching and gift boxing on request.",
        features: [
            "Drum-dyed, full-grain leathers",
            "RFID-ready constructions",
            "Contrast stitching & edge painting",
            "Custom logo embossing",
            "Gift-box packaging available",
            "MOQ from 100 units",
        ],
        category: "Men's Wallets",
        items: [
            { img: "/assets/wallet-1.jpeg", title: "Onyx Stripe Bifold" },
            { img: "/assets/wallet-2.jpeg", title: "Saddle Stitch Bifold" },
            { img: "/assets/wallet-4.jpeg", title: "Onyx Tab Bifold" },
            { img: "/assets/wallet-3.jpeg", title: "Saddle Stitch — Reverse" },
        ],
    },
    candles: {
        slug: "candles",
        series: "The Ember Atelier",
        title: "Handmade Candles",
        sub: "Botanical · Scented · Gift Collections",
        description:
            "Hand-poured in small batches — floral bouquets, floating bowls and sculpted jar candles in soy and beeswax. Signature scents, bespoke vessels and private-label gift sets for retailers and corporate programs.",
        features: [
            "Hand-poured soy & beeswax",
            "Signature & bespoke scent blends",
            "Floral, floating & jar formats",
            "Private label & gift packaging",
            "Retail-ready & corporate gifting",
            "Sample kits shipped worldwide",
        ],
        category: "Handmade Candles",
        items: [
            { img: "/assets/candle-1.png", title: "Sunflower Harvest Bouquet" },
            { img: "/assets/candle-2.png", title: "Daisy Meadow Platter" },
            { img: "/assets/candle-3.png", title: "Rose Bloom Jar" },
            { img: "/assets/candle-4.png", title: "Floating Petal Bowl" },
            { img: "/assets/candle-5.png", title: "Sunflower Crystal Jar" },
        ],
    },
    magnets: {
        slug: "magnets",
        series: "The Keepsake Studio",
        title: "Fridge Magnets",
        sub: "Souvenir · Floral Vase · Custom Artwork",
        description:
            "Miniature vase magnets with hand-beaded flowers, souvenir series and custom resin artwork. Built for gift retail, travel shops and promotional programs — your themes, your cities, your brand.",
        features: [
            "Hand-beaded floral vase magnets",
            "Custom city & souvenir themes",
            "Private artwork to your design",
            "Display boards & retail sets",
            "Gift & promotional programs",
            "Sample kits shipped worldwide",
        ],
        category: "Fridge Magnets",
        items: [
            { img: "/assets/magnet-2.png", title: "The Keepsake Display Board" },
            { img: "/assets/magnet-3.png", title: "Ruby Rose Vase Magnet" },
            { img: "/assets/magnet-1.png", title: "Azure Blossom Vase Magnet" },
            { img: "/assets/magnet-4.png", title: "Blush Tulip Vase Magnet" },
            { img: "/assets/magnet-5.png", title: "Lilac Bloom Vase Magnet" },
        ],
    },
};

export const COLLECTION_LINKS = [
    { slug: "leather-bags", label: "Leather Bags" },
    { slug: "wallets", label: "Men's Wallets" },
    { slug: "candles", label: "Handmade Candles" },
    { slug: "magnets", label: "Fridge Magnets" },
];
